var _excluded = ["title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from 'react';
import { pure } from 'recompose';
import SvgIcon from "../../SvgIcon";
var SvgInfoFilled = function SvgInfoFilled(_ref) {
  var _ref$title = _ref.title,
    title = _ref$title === void 0 ? 'Filled Info' : _ref$title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(SvgIcon, _extends({
    title: title
  }, props, {
    viewBox: "0 0 48 48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24,0 C10.752,0 0,10.752 0,24 C0,37.248 10.752,48 24,48 C37.248,48 48,37.248 48,24 C48,10.752 37.248,0 24,0 Z M26.4,17 L21.6,17 L21.6,12.2 L26.4,12.2 L26.4,17 Z M26.4,36.4 L21.6,36.4 L21.6,22 L26.4,22 L26.4,36.4 Z"
  }));
};
SvgInfoFilled = pure(SvgInfoFilled);
SvgInfoFilled.displayName = 'SvgInfoFilled';
export default SvgInfoFilled;